import { render, staticRenderFns } from "./Live-Chat.vue?vue&type=template&id=ecb1cc6a&"
import script from "./Live-Chat.vue?vue&type=script&lang=js&"
export * from "./Live-Chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports